export default __webpack_public_path__ + "static/eagle-d7f2750a55167f625422a9cf94d97083.svg";